/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-08-30 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Card, TextStyle, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import Carousel from 'react-multi-carousel';

import { RECOMMENDED_APPS } from 'src/constants/recommended-apps';
import { RenderTooltip } from 'src/components/views/common/render-tooltip';
import { routes } from 'src/routes';
import history from 'src/routes/history';

type Props = {};

type ComposedProps = Props & WithI18nProps;
class RecommendedApps extends Component<ComposedProps> {
  render() {
    let { i18n } = this.props;
    return (
      <div className="BC-RecommendedApp__Dashboard">
        <Card
          title={
            <div>
              <span className="Polaris-Heading">
                {i18n.translate('AdminHTML.Dashboard.RecommendedApps.cardTitle_Span')}
              </span>
              <span className="tooltip" style={{ margin: '3px 0 0' }}>
                <RenderTooltip
                  content={i18n.translate('AdminHTML.Dashboard.RecommendedApps.cardTitle_Tooltip', {
                    t1: (
                      <Link onClick={() => history.push(routes.integration.view())}>
                        {i18n.translate('AdminHTML.Dashboard.RecommendedApps.cardTitle_Tooltip_t1')}
                      </Link>
                    )
                  })}
                  icon={true}
                />
              </span>
            </div>
          }>
          <Card.Section>
            <Carousel
              additionalTransfrom={0}
              arrows
              autoPlaySpeed={3000}
              centerMode={false}
              className=""
              containerClass="BC_RecommendedApps-Sliders"
              dotListClass="BC_RecommendedApps-Sliders_Dot-list"
              draggable
              focusOnSelect={false}
              infinite
              itemClass=""
              keyBoardControl
              minimumTouchDrag={80}
              pauseOnHover
              renderArrowsWhenDisabled={false}
              renderButtonGroupOutside={false}
              renderDotsOutside={true}
              responsive={{
                desktop: {
                  breakpoint: {
                    max: 3000,
                    min: 1024
                  },
                  items: 3,
                  partialVisibilityGutter: 40
                },
                mobile: {
                  breakpoint: {
                    max: 464,
                    min: 0
                  },
                  items: 1,
                  partialVisibilityGutter: 30
                },
                tablet: {
                  breakpoint: {
                    max: 1024,
                    min: 464
                  },
                  items: 2,
                  partialVisibilityGutter: 30
                }
              }}
              rewind={false}
              rewindWithAnimation={false}
              rtl={false}
              shouldResetAutoplay
              showDots={true}
              sliderClass=""
              slidesToSlide={window.innerWidth >= 1024 ? 3 : window.innerWidth >= 464 ? 2 : 1}
              swipeable>
              {_.map(RECOMMENDED_APPS, (app, index) => {
                const { name, image, description, url } = app;
                return (
                  <div key={`item-` + index}>
                    <div className="title">
                      <a
                        className="Polaris-Link"
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer">
                        <img className="icon" src={image.source} alt={name} />
                      </a>
                      {/* App name*/}
                      <div className="name">
                        <a
                          className="Polaris-Link-Content"
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer">
                          <TextStyle variation="strong">{name}</TextStyle>
                        </a>
                      </div>
                    </div>
                    {/* App description*/}
                    <div className="description">
                      <TextStyle variation="subdued">{description}</TextStyle>
                    </div>
                  </div>
                );
              })}
            </Carousel>
          </Card.Section>
        </Card>
      </div>
    );
  }
}

export default withI18n()(RecommendedApps);
